<div style="color: white; font-size: 12px;" data-cy="home-schedule-view">
  Schedule for<br />
  <div style="display: flex; padding: 1px 0;" data-cy="home-schedule-view-header">
    <div style="flex: 1; height: 30px; margin-right: 12px; display: flex;" data-cy="home-schedule-view-doctor-selector-container">
      <div style="flex: 1; height: 30px; background-color: white; border: 1px solid var(--tdo-secondary-accent); border-radius: var(--border-radius); padding: 0 6px 6px 6px;" data-cy="home-schedule-view-doctor-dropdown-container">
        <tdo-dropdown-v2 style="position: relative; top: 2px;" label="Choose doctor" 
          #doctorScheduleDropdown
          [value]="selectedDoctor"
          [isPreventMouseEventPropagation]="true"
          (selectionChange)="onDoctorSelected($event)"
          [datasource]="staticDataService.currentLocationDoctors" 
          [displayPredicate]="doctorPredicate" data-cy="home-schedule-view-doctor-dropdown"
          [hideSingleSelectionIndicator]="true">
        </tdo-dropdown-v2>
      </div>
      <div (click)="onClearDoctor()" style="flex-basis: fit-content; color: var(--tdo-secondary-accent); margin-top: 4px; margin-left: 3px; cursor: pointer;" data-cy="home-schedule-view-clear-doctor">
        <lucide-icon name="x" [size]="20"></lucide-icon>
      </div>
      <!--          APPOINTMENTS-->
    </div>
    <div matTooltip="Scheduler" style="flex-basis: fit-content; margin-top: 4px;" data-cy="home-schedule-view-scheduler-icon-container">
      <img src="assets/Images/navbar-icons/v2/calendar.svg" style="cursor: pointer;" (click)="onScheduleIconClick()" data-cy="home-schedule-view-scheduler-icon" />
    </div>
  </div>
  @if (currAndFutureAppointments.length > 0) {
    <div class="patient-cells" style="margin-top: 2px; margin-bottom: 4px; max-height: 600px;" data-cy="home-schedule-view-appointments-container">
      <!--<div *ngFor="let appt of currAndFutureAppointments" class="patient-cell" style="cursor: pointer;" (click)="changePatient(appt)" (contextmenu)="onPatientContextMenu($event, appt); false">-->
      @for (appt of filteredAppointments; track appt) {
        <div class="patient-cell" [style.background-color]="getBackgroundColor(appt)" style="cursor: pointer; display: flex; flex-direction: column;" (click)="changePatient(appt)" data-cy="home-schedule-view-appointment-{{appt.AppointmentId}}">
          @if (appt?.dataPatientFlags?.length > 0) {
            <div style="display: flex; flex-basis: 30px; flex-wrap: wrap; margin-bottom: 10px; background-color: #f1f1f1; border-radius: 4px; padding: 3px;" data-cy="home-schedule-view-patient-flags">
              @for (flag of appt.dataPatientFlags; track flag) {
                <img style="width: 30px; height: 30px; margin-right: 2px;" [src]="getPatientFlagImage(flag)" [matTooltip]="getPatientFlagTooltip(flag)" data-cy="home-schedule-view-patient-flag-{{flag.EnumDataPatientFlagID}}" />
              }
            </div>
          }
          <div style="display: flex; flex: 1;" data-cy="home-schedule-view-appointment-content">
            <div style="flex-basis: fit-content;" data-cy="home-schedule-view-patient-image-container">
              <img [src]="appt.PatientImageUrl | secureImage | async" style="width: 32px; height: 32px; border-radius: 6px; border: 1px solid #cccccc;" data-cy="home-schedule-view-patient-image">
            </div>
            <div style="flex: 1; color: black; line-height: 1.2; margin-left: 12px; margin-right: 12px;" data-cy="home-schedule-view-appointment-details">
              <div style="font-size: 14px; font-weight: 500;" data-cy="home-schedule-view-patient-name">
                {{appt.PatientName}}
              </div>
              <div style="font-size: 12px; margin-top: 2px;" data-cy="home-schedule-view-appointment-time">
                <!--{{getStartTime(appt)}} &bull; {{getDuration(appt)}}-->
                {{getStartTime(appt)}} - {{getDuration(appt)}}
                <br />
                @if (appt.teeth.length > 0) {
                  <div data-cy="home-schedule-view-appointment-teeth">Tooth @for (t of appt.teeth; track $index) {
                    <span data-cy="home-schedule-view-appointment-tooth-{{t}}">#{{t}}</span>
                  }</div>
                }
              </div>
              <div style="font-weight: 500;" data-cy="home-schedule-view-appointment-type">
                <div data-cy="home-schedule-view-appointment-type-switch">
                  @switch (appt.enumApptTypeId) {
                    @case ('00000071-0000-0000-0000-000000000004') {
                      <div data-cy="home-schedule-view-teledentistry">
                        <mat-icon style="color:green;" matTooltip="Tele Dentistry Call / Video Consultation" data-cy="home-schedule-view-teledentistry-icon">
                          video_call
                        </mat-icon>
                      </div>
                    }
                    @default {
                      <div data-cy="home-schedule-view-operatory">
                        @if (getOperatoryImage(appt.OperatoryId)) {
                          <img style="height: 20px;" src="{{getOperatoryImage(appt.OperatoryId)}}" data-cy="home-schedule-view-operatory-image">
                          } <span style="position: relative; top: 2px; left: 2px;" data-cy="home-schedule-view-operatory-name">{{getOperatoryName(appt.OperatoryId)}}</span>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
              <div style="flex-basis: 70px; display: flex; flex-direction: column;" data-cy="home-schedule-view-appointment-actions">
                @if (!appt.isCheckedIn && appt.isTodayAppointment) {
                  <button (click)="onCheckInPatient($event, appt)" style="margin-top: 4px; border: unset; outline: unset; background-color: unset; height: 40px;" matTooltip="Check In" data-cy="home-schedule-view-checkin-button"><img style="height: 100%;" src="assets/Images/defaultImages/Login.svg" data-cy="home-schedule-view-checkin-icon" /></button>
                }
                @if (appt.isCheckedIn && appt.isTodayAppointment) {
                  <button (click)="onCheckOutPatient($event, appt)" style="margin-top: 4px; border: unset; outline: unset; background-color: unset; height: 40px;" matTooltip="Check Out" data-cy="home-schedule-view-checkout-button"><img style="height: 100%;" src="assets/Images/defaultImages/Logout.svg" data-cy="home-schedule-view-checkout-icon" /></button>
                }
              </div>
            </div>
            @if (appt?.dataAppointmentFlags?.length > 0) {
              <div style="display: flex; flex-basis: 30px; flex-wrap: wrap; margin-top: 10px; background-color: #f1f1f1; border-radius: 4px; padding: 3px;" data-cy="home-schedule-view-appointment-flags">
                @for (flag of appt.dataAppointmentFlags; track flag) {
                  <img style="width: 30px; height: 30px; margin-right: 2px;" [src]="getAppointmentFlagImage(flag)" [matTooltip]="getAppointmentFlagTooltip(flag)" data-cy="home-schedule-view-appointment-flag-{{flag.EnumDataAppointmentFlagID}}" />
                }
              </div>
            }
          </div>
        }
      </div>
    }
    @if (currAndFutureAppointments.length == 0) {
      <div style="margin-top: 16px; margin-bottom: 12px; width: 100%; text-align: center; font-size: 14px;" data-cy="home-schedule-view-no-appointments">
        No scheduled appointments
      </div>
    }
  </div>

  <ng-template #ctxMenu let-data>
    <section class="context-menu" data-cy="home-schedule-view-context-menu">
      <div (click)="onCheckInPatient($event, data)" class="item" data-cy="home-schedule-view-context-menu-checkin">Check In</div>
      <div (click)="onCheckOutPatient($event, data)" class="item" data-cy="home-schedule-view-context-menu-checkout">Check Out</div>
    </section>
  </ng-template>
